/**
 * Product Page Tabs Integration
 * Uses Tabby.js to organize product info into Overview and More Info tabs
 */

(function() {
  'use strict';

  function initProductTabs() {
    const observer = new MutationObserver((mutations, obs) => {
      const apoContainer = document.querySelector('.mw-apo-container');

      const productInfoContainer = document.querySelector('.product__info-container');
const productDescription = document.querySelector('.product__description');

if (!productInfoContainer || !productDescription) {
  return;
}

// Add loading class
productInfoContainer.classList.add('loading');

      if (apoContainer) {
        // console.log('APO container detected, initializing tabs...');
        obs.disconnect(); // Stop observing once APO is loaded

        // Get the main product info container
        const productInfoContainer = document.querySelector('.product__info-container');
        const productDescription = document.querySelector('.product__description');

        if (!productInfoContainer || !productDescription) {
          return;
        }

        // Check if tabs already initialized
        if (document.querySelector('.product-tabs-container')) {
        //   console.log('Tabs already initialized');
          return;
        }

        // Create tab structure (Tabby-compatible)
        const tabsContainer = document.createElement('div');
        tabsContainer.className = 'product-tabs-container';

        tabsContainer.innerHTML = `
          <ul class="product-tabs" data-tabs>
            <li>
              <a data-tabby-default href="#tab-overview">Overview</a>
            </li>
            <li>
              <a href="#tab-more-info">More Info</a>
            </li>
          </ul>

          <div id="tab-overview">
            <!-- Overview content will be moved here -->
          </div>

          <div id="tab-more-info">
            <!-- Description will be moved here -->
          </div>
        `;

        // Get all product info children (everything except description)
        const productInfoChildren = Array.from(productInfoContainer.children);
        const overviewTab = tabsContainer.querySelector('#tab-overview');
        const moreInfoTab = tabsContainer.querySelector('#tab-more-info');

        // Move all children to Overview tab, except description
        productInfoChildren.forEach(child => {
          if (!child.classList.contains('product__description')) {
            overviewTab.appendChild(child);
          }
        });

        // Move description to More Info tab
        moreInfoTab.appendChild(productDescription);

        // Replace product info container content with tabs
        productInfoContainer.innerHTML = '';
        productInfoContainer.appendChild(tabsContainer);

        // Add some basic styles
        addTabStyles();

        // Initialize Tabby
        if (typeof Tabby !== 'undefined') {
        //   console.log('Initializing Tabby...');
          const tabs = new Tabby('[data-tabs]');
        //   console.log('Tabby initialized successfully', tabs);
        } else {
        //   console.log('Tabby not loaded, using fallback tab functionality');
          initFallbackTabs();
        }

        // Wait a bit for the custom-product script to add the quote buttons
        setTimeout(() => {
          moveFirstDescriptionBit(overviewTab, moreInfoTab);
          reorganizeButtons(overviewTab);

            // Remove loading class when done
  productInfoContainer.classList.remove('loading');
        }, 500);
      }
    });

    // Start observing the document body for APO container
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Move first h3 and p from description to overview (above price)
  function moveFirstDescriptionBit(overviewTab, moreInfoTab) {
    // console.log('Moving first description snippet to overview...');

    const productDescription = moreInfoTab.querySelector('.product__description');
    if (!productDescription) {
      console.error('Product description not found');
      return;
    }

    // Find the first h3 and first p
    const firstH3 = productDescription.querySelector('h3');
    const firstP = productDescription.querySelector('p');

    if (!firstH3 || !firstP) {
      console.error('First h3 or p not found in description');
      return;
    }

    // console.log('Found first h3:', firstH3.textContent.trim());
    // console.log('Found first p:', firstP.textContent.trim());

    // Create a container for the excerpt
    const excerptContainer = document.createElement('div');
    excerptContainer.className = 'product__description-excerpt';
    excerptContainer.style.marginTop = '1rem';
    excerptContainer.style.marginBottom = '1rem';

    // Clone and move the first h3 and p
    excerptContainer.appendChild(firstH3.cloneNode(true));
    excerptContainer.appendChild(firstP.cloneNode(true));

    // Remove them from the original description
    firstH3.remove();
    firstP.remove();

    // Find the product title and price to insert between them
    const productTitle = overviewTab.querySelector('.product__title');
    const priceElement = overviewTab.querySelector('.price');

    if (productTitle && priceElement) {
      // Insert after title, before price
      productTitle.insertAdjacentElement('afterend', excerptContainer);
    //   console.log('Inserted excerpt after title, before price');
    } else if (priceElement) {
      // Fallback: insert before price
      priceElement.insertAdjacentElement('beforebegin', excerptContainer);
    //   console.log('Inserted excerpt before price');
    } else {
      // Last resort: add at top of overview
      overviewTab.insertBefore(excerptContainer, overviewTab.firstChild);
    //   console.log('Inserted excerpt at top of overview');
    }
  }

  // Reorganize buttons: reverse order at top and bottom
  function reorganizeButtons(overviewTab) {
    // console.log('Reorganizing buttons...');
    
    // Find the original button container (Get a Quote | OR | Add to Cart)
    const originalButtonContainer = overviewTab.querySelector('.product-form__buttons');
    const quoteUnderTitle = overviewTab.querySelector('.mw-quote-under-title');
    
    // Find the price element itself (not its parent)
    const priceElement = overviewTab.querySelector('.price');
    
    if (!originalButtonContainer) {
      console.error('Button container not found');
      return;
    }

    // Get the actual action buttons (skip the OR separator)
    const getQuoteButton = originalButtonContainer.querySelector('.mw-added-or-duplicate');
    const addToCartButton = originalButtonContainer.querySelector('.mw-apo-add-to-cart-cloned:not(.mw-added-or-duplicate)');

    if (!getQuoteButton || !addToCartButton) {
      console.error('Buttons not found', { getQuoteButton, addToCartButton });
      return;
    }

    // console.log('Found buttons:', { getQuoteButton, addToCartButton });
    // console.log('Found price element:', priceElement);

    // Store references to original buttons
    let originalGetQuote = getQuoteButton;
    let originalAddToCart = addToCartButton;

    // Create reversed button container (Add to Cart | Get a Quote)
    function createReversedButtonContainer(isTop = false) {
      const container = document.createElement('div');
      container.className = 'product-form__buttons reversed-buttons';
      container.style.display = 'flex';
      container.style.gap = '10px';
      container.style.marginTop = '1rem';
      container.style.marginBottom = '1rem';

      // Clone Add to Cart button (comes first now)
      const addToCartClone = originalAddToCart.cloneNode(true);
      addToCartClone.classList.add('cloned-add-to-cart');
      
      // Remove the old click handler and add a new one
      addToCartClone.addEventListener('click', function(e) {
        // console.log('Cloned Add to Cart clicked, triggering original');
        e.preventDefault();
        e.stopPropagation();
        
        // Trigger a real click on the original button
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        originalAddToCart.dispatchEvent(clickEvent);
      });

      // Clone Get a Quote button (comes second now)
      const getQuoteClone = originalGetQuote.cloneNode(true);
      getQuoteClone.classList.add('cloned-get-quote');
      
      getQuoteClone.addEventListener('click', function(e) {
        // console.log('Cloned Get a Quote clicked, triggering original');
        e.preventDefault();
        e.stopPropagation();
        
        // Trigger a real click on the original button
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        originalGetQuote.dispatchEvent(clickEvent);
      });

      container.appendChild(addToCartClone);
      container.appendChild(getQuoteClone);

      return container;
    }

    // 1. TOP: Place after the price element
    const topButtons = createReversedButtonContainer(true);
    topButtons.classList.add('top-buttons');

    if (priceElement) {
      // Insert directly after the price element
    //   console.log('Inserting top buttons after price element');
      priceElement.insertAdjacentElement('afterend', topButtons);
    } else if (quoteUnderTitle) {
      // Fallback: Replace the existing quote button under title
    //   console.log('Price not found, replacing quote under title');
      quoteUnderTitle.replaceWith(topButtons);
    } else {
      // Last resort: add at the very top of overview
    //   console.log('Price and quote button not found, adding to top of overview');
      overviewTab.insertBefore(topButtons, overviewTab.firstChild);
    }

    // Remove the old .mw-quote-under-title if it still exists
    if (quoteUnderTitle && quoteUnderTitle.parentNode) {
      quoteUnderTitle.remove();
    }

    // 2. BOTTOM: Replace the original button container with reversed version
    const bottomButtons = createReversedButtonContainer(false);
    bottomButtons.classList.add('bottom-buttons');
    bottomButtons.style.marginTop = '1rem';
    
    // Important: Keep the original buttons hidden but in the DOM for their event handlers
    originalButtonContainer.style.display = 'none';
    originalButtonContainer.classList.add('original-buttons-hidden');
    
    // Insert the new buttons before the hidden originals
    originalButtonContainer.insertAdjacentElement('beforebegin', bottomButtons);

    // Keep buttons in sync with originals (text and disabled state)
    const syncObserver = new MutationObserver(() => {
      syncAllDuplicateButtons();
    });

    syncObserver.observe(originalGetQuote, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    syncObserver.observe(originalAddToCart, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    function syncAllDuplicateButtons() {
      const allClonedAddToCarts = overviewTab.querySelectorAll('.cloned-add-to-cart');
      const allClonedGetQuotes = overviewTab.querySelectorAll('.cloned-get-quote');

      allClonedAddToCarts.forEach(clone => {
        const span = clone.querySelector('span');
        const originalSpan = originalAddToCart.querySelector('span');
        if (span && originalSpan) {
          span.textContent = originalSpan.textContent;
        }
        clone.disabled = originalAddToCart.disabled;
      });

      allClonedGetQuotes.forEach(clone => {
        const span = clone.querySelector('span');
        const originalSpan = originalGetQuote.querySelector('span');
        if (span && originalSpan) {
          span.textContent = originalSpan.textContent;
        }
        clone.disabled = originalGetQuote.disabled;
      });
    }

    // console.log('Buttons reorganized successfully');
  }

  // Fallback tab functionality if Tabby isn't loaded
  function initFallbackTabs() {
    // console.log('Initializing fallback tabs...');
    const tabLinks = document.querySelectorAll('.product-tabs a');
    
    // Show first tab by default
    const firstPanel = document.querySelector(tabLinks[0].getAttribute('href'));
    if (firstPanel) firstPanel.style.display = 'block';

    tabLinks.forEach((link) => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        // console.log('Tab clicked:', this.textContent.trim());

        // Hide all panels
        tabLinks.forEach(l => {
          const panel = document.querySelector(l.getAttribute('href'));
          if (panel) panel.style.display = 'none';
          l.classList.remove('active');
        });

        // Show clicked panel
        const targetId = this.getAttribute('href');
        const targetPanel = document.querySelector(targetId);

        if (targetPanel) {
          targetPanel.style.display = 'block';
          this.classList.add('active');
        //   console.log('Showing panel:', targetId);
        }
      });
    });
  }

  // Add basic tab styles
  function addTabStyles() {
    const styleId = 'product-tabs-styles';

    // Don't add styles if already present
    if (document.getElementById(styleId)) {
      return;
    }

    const style = document.createElement('style');
    style.id = styleId;
    console.log('hiz')
    style.textContent = `
      .product-tabs-container {
        width: 100%;
      }

      .product-tabs {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0 0 20px 0;
        border-bottom: 2px solid #e5e5e5;
        gap: 10px;
      }

      .product-tabs li {
        margin: 0;
      }

      .product-tabs a {
        display: block;
        padding: 12px 24px;
        text-decoration: none;
        color: #333;
        border-bottom: 3px solid transparent;
        transition: all 0.3s ease;
        font-weight: 500;
        position: relative;
        bottom: -2px;
        cursor: pointer;
      }

      .product-tabs a:hover {
        color: #000;
        border-bottom-color: #ccc;
      }

      .product-tabs a.active,
      .product-tabs a[aria-selected="true"] {
        color: #000;
        border-bottom-color: #000;
        font-weight: 600;
      }

      /* Tabby adds these classes */
      #tab-overview,
      #tab-more-info {
        padding: 20px 0;
      }

      #tab-overview[aria-hidden="true"],
      #tab-more-info[aria-hidden="true"] {
        display: none;
      }

      /* Reversed buttons styling - force horizontal layout */
      .reversed-buttons {
        display: flex !important;
        flex-direction: row !important;
        gap: 10px !important;
        flex-wrap: nowrap !important;
      }

      .reversed-buttons button {
        flex: 1 !important;
        min-width: 0 !important;
        max-width: none !important;
        width: auto !important;
      }

      /* Mobile specific - keep buttons horizontal */
      @media screen and (max-width: 749px) {
        .reversed-buttons {
          display: flex !important;
          flex-direction: row !important;
          gap: 8px !important;
        }

        .reversed-buttons button {
          flex: 1 !important;
          font-size: 14px !important;
          padding: 10px 8px !important;
          min-width: 0 !important;
        }
      }

      /* Hide original buttons but keep in DOM */
      .original-buttons-hidden {
        display: none !important;
      }

      /* Description excerpt styling */
      .product__description-excerpt {
        line-height: 1.6;
      }

      .product__description-excerpt h3 {
        margin-top: 0;
      }

      .price-item {
        color: grey;
        font-size: 14px;
      }

      .product__description {
        margin: 0 !important;
      }

            /* Hide top buttons, keep bottom buttons */
      .top-buttons {
        display: none !important;
      }

      /* Skeleton loading */
      .product__info-container.loading {
        position: relative;
        min-height: 1300px;
        pointer-events: none;
      }

      .product__info-container.loading > * {
        visibility: hidden;
      }

      .product__info-container.loading::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image:
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0),
          linear-gradient(#e0e0e0 30px, transparent 0);
        background-size:
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px,
          90% 30px;
        background-position:
          0 0,
          0 68px,
          0 136px,
          0 204px,
          0 272px,
          0 340px,
          0 408px,
          0 476px,
          0 544px,
          0 612px,
          0 680px,
          0 748px,
          0 816px,
          0 884px,
          0 952px,
          0 1020px,
          0 1088px,
          0 1156px,
          0 1224px;
        background-repeat: no-repeat;
        animation: skeleton-shimmer 1.5s ease-in-out infinite;
        z-index: 1000;
      }

      @keyframes skeleton-shimmer {
        0% {
          opacity: 0.6;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.6;
        }
      }
    `;

    document.head.appendChild(style);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }
})();